import { countryToRelavanceWord } from '@application/types';
import { useRouter } from '@application/utils';
import type { DogBreederOrderByWithRelationAndSearchRelevanceInput } from '@gql/graphql';
import { CountryCode, DogBreederOrderByRelevanceFieldEnum, SortOrder } from '@gql/graphql';
import { BreederListSortType } from '@presentation/pages';
import { useCallback } from 'react';

export const useBreederOrderBuilder = () => {
  const { countryCode } = useRouter();

  const breederOrderBuilder = useCallback(
    (sortBy?: BreederListSortType): DogBreederOrderByWithRelationAndSearchRelevanceInput[] => {
      if (sortBy === BreederListSortType.CONNECTION_ASC) {
        return [
          {
            account: { connectedAt: SortOrder.asc },
          },
        ];
      }

      if (sortBy === BreederListSortType.CONNECTION_DESC) {
        return [{ account: { connectedAt: SortOrder.desc } }];
      }

      if (sortBy === BreederListSortType.RATING_ASC) {
        return [{ reviews: { _count: SortOrder.asc } }];
      }

      if (sortBy === BreederListSortType.RATING_DESC) {
        return [{ reviews: { _count: SortOrder.desc } }];
      }

      return [
        {
          _relevance: {
            fields: [DogBreederOrderByRelevanceFieldEnum.tags],
            search: 'has <-> litters',
            sort: SortOrder.desc,
          },
        },
        ...(countryCode !== CountryCode.EU
          ? [
              {
                _relevance: {
                  fields: [DogBreederOrderByRelevanceFieldEnum.tags],
                  search: `${countryToRelavanceWord[countryCode]}`,
                  sort: SortOrder.desc,
                },
              },
            ]
          : []),
        { account: { connectedAt: SortOrder.desc } },
      ];
    },
    [countryCode],
  );

  return { breederOrderBuilder };
};
